module.exports = __webpack_public_path__ + "static/media/horse.c9d92da7.mp3";